type UpdateUrlDomainsToAkasaArgs = {
  dataToUpdate: string | Record<string, any>;
};

export const replaceSbDomainWithAkasa = (stringToUpdate: string) => {
  const akasaDomainName = process.env.NEXT_PUBLIC_ASSET_DOMAIN_NAME || "a.storyblok.com";
  const storyblokDomainRegex = /a\.storyblok\.com\/.*?(?=["'\\])/g;

  const optimizedData = stringToUpdate.replace(storyblokDomainRegex, (match) => {
    const replacedString = match.replace("a.storyblok.com", akasaDomainName);
    const fileExtension = replacedString.split(".").pop() || "";

    if (["jpg", "jpeg", "png", "gif"].includes(fileExtension)) {
      return `${replacedString}/m/filters:format(webp)`;
    }

    return replacedString;
  });

  return optimizedData;
};

export const replaceSbJsonWithAkasaDomain = (jsonToUpdate: Record<string, any>) => {
  const stringifiedJsonData = JSON.stringify(jsonToUpdate);
  return JSON.parse(replaceSbDomainWithAkasa(stringifiedJsonData));
};

export function replaceAllSbDomainsWithAkasa({ dataToUpdate }: UpdateUrlDomainsToAkasaArgs) {
  try {
    if (typeof dataToUpdate === "string") {
      return replaceSbDomainWithAkasa(dataToUpdate);
    }
    return replaceSbJsonWithAkasaDomain(dataToUpdate);
  } catch (error: any) {
    console.warn("error in switching the url domain :", error);
    return dataToUpdate;
  }
}
